import type { SectionHeaderProps } from './SectionHeader.types';

const FONT_SIZE = {
  default: 'text-heading-lg',
  small: 'text-heading-sm',
} as const satisfies Record<string, string>;

/**
 * Title standing over a section of content, matching the IQ analysis report's
 * sub-section heading: the words alone.
 *
 * The icon tile this used to lead with is gone, and with it the colour that only
 * ever tinted that tile. A row of coloured squares gave each section a badge the
 * reader had to decode before reaching the words, and it set these reports apart
 * from IQ's for no reason either report could name.
 */
export const SectionHeader = ({ title, size = 'default', action }: SectionHeaderProps) => (
  <div className="flex items-center gap-4">
    <h2 className={`${FONT_SIZE[size]} font-medium text-foreground`}>{title}</h2>
    {action != null && <div className="ml-auto flex shrink-0 items-center">{action}</div>}
  </div>
);
